function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("clipPath", {
  id: "_clip1"
}, /*#__PURE__*/React.createElement("rect", {
  x: 70.994,
  y: 9.469,
  width: 37.038,
  height: 37.038
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#_clip1)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  id: "Dialog",
  transform: "matrix(1.23459,0,0,1.23459,70.994,9.46863)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M21,26L15,26L12,30L8,30L8,26L1,26L1,5.132L3,0L29,0L29,18L21,26ZM26,17L26,3L5,3L5,22L11,22L11,26L15,22L21,22L26,17Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "_x7C_",
  transform: "matrix(1.23459,0,0,1.23459,70.994,9.46863)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 18,
  y: 8,
  width: 3,
  height: 8
})), /*#__PURE__*/React.createElement("g", {
  id: "_x7C__1_",
  transform: "matrix(1.23459,0,0,1.23459,70.994,9.46863)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 12,
  y: 8,
  width: 3,
  height: 8
}))));

var SvgTwitch = function SvgTwitch(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 61 60",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41421
    },
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-69,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "twitch",
    transform: "matrix(1.61997,0,0,1.61997,-45.6389,-15.3389)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 70.994,
    y: 9.469,
    width: 37.038,
    height: 37.038,
    style: {
      fill: "none"
    }
  }), _ref2, _ref3)));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTwitch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/twitch.38db2bc1.svg";
export { ForwardRef as ReactComponent };